// import MyLoader from './path to some component'

// eslint-disable-next-line no-unused-vars
function plugin(Vue) {
  // Vue.component(MyLoader);
}

if (typeof window !== 'undefined' && (window as any).Vue) {
  (window as any).Vue.use(plugin);
}
export default plugin;
